import { Col } from '@opendoor/atoms/box';
import type { AddressSearchLocation } from 'components/globals';
import type { ILpComponentContextualFields } from 'declarations/contentful';

import NewSellerFlowAddressInput from '../../components/shared/NewSellerFlowAddressInput';
import { AgentSelectListBox, SupportListBox } from './shared/ListBox';
import type { IComponentThemeOptions } from './shared/styles/ComponentTheme';

interface IContextualFieldProps {
  contextFields: ILpComponentContextualFields;
  theme: IComponentThemeOptions;
  inputLocation: AddressSearchLocation;
}

const ContextualField = ({ contextFields, theme, inputLocation }: IContextualFieldProps) => {
  const fields = contextFields.fields;

  // set the page set for address entry on home guide alt landing page
  const pageSetPath =
    contextFields.fields.analyticsId === 'homeguide-ae'
      ? '?seller_flow=home_guide_nav_entry'
      : undefined;

  // build agent links array
  const agentLinkOptions = [];
  if (contextFields.fields.agentLinkOneText && contextFields.fields.agentLinkOneUrl) {
    agentLinkOptions.push({
      label: contextFields.fields.agentLinkOneText,
      href: contextFields.fields.agentLinkOneUrl,
    });
  }

  if (contextFields.fields.agentLinkTwoText && contextFields.fields.agentLinkTwoUrl) {
    agentLinkOptions.push({
      label: contextFields.fields.agentLinkTwoText,
      href: contextFields.fields.agentLinkTwoUrl,
    });
  }

  if (contextFields.fields.agentLinkThreeText && contextFields.fields.agentLinkThreeUrl) {
    agentLinkOptions.push({
      label: contextFields.fields.agentLinkThreeText,
      href: contextFields.fields.agentLinkThreeUrl,
    });
  }

  switch (fields.contextualField) {
    case 'address-search':
      return (
        <>
          <Col id="desktop-address-search" className="z-[2] max-md:hidden md:w-128">
            <NewSellerFlowAddressInput
              hideLabel
              inputLocation={inputLocation}
              analyticsPrefix={contextFields.fields.analyticsId || ''}
              trackingTaxonomy="new_homepage"
              placeholder={fields.addressInputPlaceholderText || 'Enter your home address'}
              pageSetPath={pageSetPath}
              trackingKeywords={contextFields.fields.trackingKeyword}
              channel={fields.channel ?? 'DEFAULT'}
            />
          </Col>
          <Col id="mobile-address-search" className="z-[2] w-full md:hidden">
            <NewSellerFlowAddressInput
              hideLabel
              inputLocation={inputLocation}
              analyticsPrefix={contextFields.fields.analyticsId || ''}
              trackingTaxonomy="new_homepage"
              placeholder={fields.addressInputPlaceholderTextSmall || 'Enter your home address'}
              pageSetPath={pageSetPath}
              trackingKeywords={contextFields.fields.trackingKeyword}
              channel={fields.channel ?? 'DEFAULT'}
            />
          </Col>
        </>
      );

    case 'agents':
      return <AgentSelectListBox theme={theme} linkOptions={agentLinkOptions} />;

    case 'support':
      return <SupportListBox theme={theme} />;

    default:
      return null;
  }
};

export default ContextualField;
